<section class="loginSection">
    <div class="dialog_header">
        <h3>Login</h3>
    </div>
    <p *ngIf="successMessage" class="loginSuccessfully">{{successMessage}}</p>
    <form [formGroup]="loginForm">
        <mat-form-field appearance="outline" class="col-md-12" floatLabel="always">
            <mat-label>Email Address</mat-label>
            <mat-icon matPrefix>mail_outline</mat-icon>
            <input matInput placeholder="Email Address" formControlName="email" appDisableCopyPaste appLowercaseInput>
            <mat-error *ngIf="loginForm.controls['email'].hasError('required')"><strong>Email</strong> is required.</mat-error>
            <mat-error *ngIf="loginForm.controls['email'].hasError('pattern')">Enter a valid <strong>Email Address</strong>.</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-md-12" floatLabel="always">
            <mat-label>Password</mat-label>
            <mat-icon matPrefix>lock_outline</mat-icon>
            <input matInput placeholder="Password" [type]="hide ? 'password' : 'text'" formControlName="password" appDisableCopyPaste>
            <button mat-icon-button matSuffix (click)="hide = !hide"><mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon></button>
            <mat-error *ngIf="loginForm.controls['password'].hasError('required')"><strong>Password</strong> is required.</mat-error>
        </mat-form-field>
        <div class="innerwrapper">
            <div class="remembersection">
                <!-- <mat-checkbox color="primary" [checked]="myModel">Remember me</mat-checkbox> -->
            </div>
            <div class="forgetSection">
                <a (click)="forgotPassword()">Forgot Password?</a>
            </div>
        </div>
        <p *ngIf="!this.COPT?.isCorporateUser()">By logging in, I understand & agree to Belairtrip <a href="/terms-and-conditions" target="_blank">Terms of Use</a> and <a href="/privacy-policy" target="_blank">Privacy Policy.</a></p>
        <button mat-button class="secoundaryBtn" [class.corporate-user]="COPT.isCorporateUser()" (click)="onSubmit()">Log In</button>
    </form>
    <!-- <div class="messageArea">
      <p class="denger">{{this.listItem}}</p>
    </div> -->
    <div class="footer_template">
        <button  color="primary" class="closeBtn" mat-dialog-close>Close</button>
    </div>
    <!-- <h3><span>Or</span></h3>
    <div class="loginButton">
        <button mat-button class="google">
            <img src="../../../assets/b2c/hotel/google.png" class="img-fluid">
            Log In with Google
        </button>
        <button mat-button class="facebook">
            <img src="../../../assets/b2c/hotel/facebook.png" class="img-fluid">
            Log In with Facebook
        </button>
    </div> -->
</section>
<app-common-loader *appLoader="isLoading" [content]="'Login'"></app-common-loader>